export default {
    APPLICATION_EXTENSION_ESTABLISHMENT_FEE_DOLLARS_MINIMUM: 0,
    APPLICATION_EXTENSION_ESTABLISHMENT_FEE_PERCENTAGE_MINIMUM: 1.5,
    BROKER_BDM_UUID_HEAD_OFFICE: 'HEAD_OFFICE',
    DATE_ISO_FORMAT: 'YYYY-MM-DDTHH:mm:ssZ',
    DEAL_ESTABLISHMENT_FEE_DOLLARS_MINIMUM: 2500,
    DEAL_ESTABLISHMENT_FEE_PERCENTAGE_DEFAULT: 2.5,
    DEAL_ESTABLISHMENT_FEE_PERCENTAGE_MINIMUM: 2.5,
    DEAL_INTEREST_RATE_BASE: 8.99,
    DEAL_INTEREST_RATE_MINIMUM: 6.95,
    DEAL_INTEREST_RATE_SECOND_MORTGAGE_MINIMUM: 17.99,
    DEAL_LEGAL_FEES_DOLLARS_DEFAULT: 1650,
    DEAL_LEGAL_FEES_DOLLARS_MINIMUM: 1250,
    DEAL_LVR_MAXIMUM: 67.5,
    IDLE_TIMEOUT_SECONDS: 900, // 15 minutes
    SCENARIO_LVR_MAXIMUM: 70,
};
